// Facebook SDK loader + login helper (JS SDK popup flow)
// Reads App ID from REACT_APP_FACEBOOK_APP_ID. If not set, loader throws.

const GRAPH_VERSION = "v21.0";

let loadingPromise;

export function isFacebookConfigured() {
  return !!(process.env.REACT_APP_FACEBOOK_APP_ID || "").trim();
}

export function loadFacebookSdk() {
  if (!isFacebookConfigured()) {
    return Promise.reject(new Error("Facebook Login non configurato"));
  }
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.FB) return Promise.resolve();
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    window.fbAsyncInit = function () {
      try {
        window.FB.init({
          appId: process.env.REACT_APP_FACEBOOK_APP_ID,
          cookie: true,
          xfbml: false,
          version: GRAPH_VERSION,
        });
        resolve();
      } catch (e) {
        reject(e);
      }
    };
    const existing = document.getElementById("facebook-jssdk");
    if (existing) {
      // script already present, wait for FB
      const check = setInterval(() => {
        if (window.FB) {
          clearInterval(check);
          resolve();
        }
      }, 100);
      setTimeout(() => clearInterval(check), 10000);
      return;
    }
    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.onerror = () => reject(new Error("Caricamento SDK Facebook fallito"));
    document.body.appendChild(script);
  });
  return loadingPromise;
}

export function facebookLogin() {
  return new Promise((resolve, reject) => {
    if (!window.FB) {
      reject(new Error("SDK Facebook non inizializzato"));
      return;
    }
    window.FB.login(
      (response) => {
        if (response?.authResponse?.accessToken) {
          resolve(response.authResponse.accessToken);
        } else {
          reject(new Error("Accesso Facebook annullato"));
        }
      },
      { scope: "public_profile,email", return_scopes: true }
    );
  });
}
